import { BaseDropdownItem, DropdownItem, DropdownValue } from '@bybeam/platform-types';
import sanitizeHtml from 'sanitize-html';
import { MultiSelectDropdownProps } from './types.js';

export function flattenOptions(options: DropdownItem[]): DropdownItem[] {
  return options.flatMap(({ label, value, ...rest }) => [
    { label, value },
    ...('children' in rest && rest.children ? flattenOptions(rest.children) : []),
  ]);
}

export function convertValuesToLabel(
  value: DropdownValue | DropdownValue[],
  items: DropdownItem[],
): string {
  if (Array.isArray(value)) {
    return flattenOptions(items)
      .filter((item) => value.find((v) => String(v) === String(item.value)))
      .map((s) => s.label)
      .join(', ');
  }
  return items.find((i) => String(i?.value) === String(value))?.label ?? '';
}

export function mapItemsToParents(
  items: DropdownItem[],
): (BaseDropdownItem & { parent?: DropdownValue })[] {
  return items.flatMap(({ label, value, ...rest }) => [
    { label, value },
    ...('children' in rest && rest.children
      ? rest.children.map((child) => ({ ...child, parent: value }))
      : []),
  ]);
}

export function filterVisibleItems(
  items: DropdownItem[],
  values: DropdownValue[],
  childMode: MultiSelectDropdownProps['childMode'],
): DropdownItem[] {
  return items.flatMap((option) => [
    option,
    ...('children' in option &&
    option.children &&
    (childMode === 'AlwaysAvailable' || values.includes(option.value))
      ? option.children.map((child) => ({ ...child, isChild: true }))
      : []),
  ]);
}

export function removeHTML(value: string | number): string {
  const updatedValue = value.toString();
  return sanitizeHtml(updatedValue, {
    allowedTags: [],
    allowedAttributes: {},
  });
}
